<template>
  <div class="change-field">
    <el-dialog title="Change Field" :visible.sync="show">
      <span>
        <el-select v-model="newField" placeholder="New field" v-loading="!fields.length">
          <el-option v-for="field in fields" 
            :key="field.id"
            :label="field.field_name"
            :value="field.id">
          </el-option>
        </el-select>
      </span>
      <div class="moveLightNickname" v-if="fields.length">
        <el-input v-model="light.nickname" placeholder="Nickname (optional)"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="cancel" @click="show = false">Cancel</el-button>
        <el-button :disabled="!newField" type="save" @click="changeField">Move</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import requests from '../../../requests'

export default {
  name: 'change-field',
  props: ['light', 'show', 'site', "save"],
  data(){
    return {
      fields: [],
      newField: ''
    }
  },
  methods: {
    changeField() {
      var context = this;

      this.light.field_id = this.newField;

      if(this.light.id > -1) {

        this.$emit('update', this.light);

      } else { // New light

        this.$emit('new', this.light);

      }
      console.log(this.light)
    }
  },
  watch: {
    show: function(val) {
      if(!val) {
        this.$emit('closeModal')
        return;
      } 

      if(!this.fields.length) {
        var context = this;
        requests.getFields(this, this.site, function(result){
          context.fields = result.data;
        });
        return;
      }      
    }
  }
}
</script>

<style>

  .moveLightNickname {
    margin: 20px 30%;
  }

</style>



// WEBPACK FOOTER //
// ChangeFieldModal.vue?964253c2